<template>
    <div>
        <v-card>
            <v-card-title>
                <v-text-field
                    v-model="buscarComponentes"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                :headers="headersPermisos"
                :items="grupo.componentes"
                :search="buscarComponentes"
            >
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            outlined
                            @click="insertarPermiso()"
                        >
                            Añadir permiso
                        </v-btn>
                    </v-toolbar>
                </template>
                <template v-slot:item.permiso="{ item }">
                    <v-chip 
                        :color="item.permisos[0].color"
                        outlined
                    >
                        {{ item.permisos[0].nombre }}
                    </v-chip>
                </template>
                <template v-slot:item.acciones="{ item }">
                    <v-icon
                        class="mr-2"
                        @click="editarPermiso(item)"
                    >
                        mdi-shield-edit-outline
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>
        
        <v-row justify="center">
            <v-dialog v-model="dialogPermiso" persistent max-width="800px">
                <v-card>
                <v-card-title class="headline">
                    {{ tituloDialog }}
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="componenteEditando.id"
                                :items="editando ? componentes : componentes.filter(componente => !grupo.componentes.some(x => x.id === componente.id))"
                                @change="vaciarPermiso()"
                                chips
                                label="Componente"
                                item-text="nombre"
                                item-value="id"
                                :disabled="editando"
                                :error-messages="errorComponente"
                                @input="$v.componenteEditando.id.$touch()"
                                @blur="$v.componenteEditando.id.$touch()"
                                class="anadirAsterisco"   
                            >
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="componenteEditando.permisos[0]"
                                :items="permisosDisponibles"
                                chips
                                label="Permiso"
                                item-text="nombre"
                                item-value="id"
                                return-object
                                :error-messages="errorPermiso"
                                @input="$v.componenteEditando.permisos.$touch()"
                                @blur="$v.componenteEditando.permisos.$touch()"
                                class="anadirAsterisco"
                            >
                                <template v-slot:selection="data">
                                    <v-chip 
                                        v-bind="data.attrs" 
                                        :input-value="data.selected" 
                                        :color="data.item.color" 
                                        outlined
                                    >
                                        {{ data.item.nombre }}
                                    </v-chip>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="error"
                        text
                        @click="quitarPermiso()"
                        v-if="editando"
                    >
                        Quitar permiso
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        @click="cerrarDialogPermiso()"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="success"
                        text
                        @click="aceptarPermiso()"
                        :disabled="$v.componenteEditando.$invalid"
                    >
                        Aceptar
                    </v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import getArrayPositionByItemId from "../../mixins/getArrayPositionByItemId";
    import axios from 'axios';
    import { required } from 'vuelidate/lib/validators';
    export default {
        name: 'PermisosGrupo',
        mixins: [getArrayPositionByItemId],
        data(){
            return {
                dialogPermiso: false,
                editando: false,
                tituloDialog: '',
                buscarComponentes: '',
                componenteSeleccionado: {
                    permisos: {}
                },
                componenteEditando: {
                    permisos: {}
                },
                headersPermisos: [
                    {
                        text: 'Componente',
                        align: 'start',
                        filterable: true,
                        sortable: true,
                        value: 'nombre',
                        width: '60%'
                    },
                    {
                        text: 'Padre',
                        filterable: true,
                        sortable: true,
                        value: 'componente_padre.nombre',
                    },
                    {
                        text: 'Permiso',
                        filterable: true,
                        sortable: true,
                        value: 'permiso',
                    },
                    {
                        text: '',
                        filterable: false,
                        sortable: false,
                        value: 'acciones'
                    }
                ]
            }
        },
        validations: {
            componenteEditando: {
                id: { required },
                permisos: { required }
            }
        },
        methods: {
            editarPermiso(item){
                this.editando = true;
                this.tituloDialog = 'Editar permisos del grupo';
                console.log(item);
                this.componenteSeleccionado = item;
                this.componenteEditando = JSON.parse(JSON.stringify(item));
                this.dialogPermiso = true;
            },
            aceptarPermiso(){
                console.log(this.componenteEditando);
                console.log(this.grupo.componentes);
                if(this.editando){
                    this.componenteSeleccionado.permisos[0].id = this.componenteEditando.permisos[0].id;
                    this.componenteSeleccionado.permisos[0].nombre = this.componenteEditando.permisos[0].nombre;
                    this.componenteSeleccionado.permisos[0].color = this.componenteEditando.permisos[0].color;
                }else{
                    this.componenteEditando.nombre = this.componentes.filter(componente => componente.id === this.componenteEditando.id)[0].nombre;
                    this.componenteEditando.componentePadre_id = this.componentes.filter(componente => componente.id === this.componenteEditando.id)[0].componentePadre_id;
                    this.grupo.componentes.push(this.componenteEditando);
                }
                this.cerrarDialogPermiso();
            },
            quitarPermiso(){
                let posicionArray = this.getArrayPositionByItemId(this.grupo.componentes, this.componenteSeleccionado.id);
                if(posicionArray >= 0){
                    this.grupo.componentes.splice(posicionArray, 1);
                }
                this.cerrarDialogPermiso();
            },
            insertarPermiso(){
                this.editando = false;
                this.tituloDialog = 'Añadir permisos al grupo';
                this.componenteEditando = {
                    id: null,
                    permisos: []
                },
                this.dialogPermiso = true;
            },
            cerrarDialogPermiso(){
                this.dialogPermiso = false;
                this.$v.$reset();
            },
            vaciarPermiso(){
                this.componenteEditando.permisos = [];
            }
        },
        mounted(){

        },
        computed: {
            ...mapState('grupos', ['grupo']),
            ...mapState('componentes', ['permisos', 'componentes']),
            permisosDisponibles(){
                // Lista los permisos disponibles para el componente seleccionado. Los componentes tienen una propiedad que indica si tienen permisos extendidos
                // (solo lectura, editar propios, editar todos). Si un grupo tiene añadido un componente sin permisos extendidos, se marcará como editar todos y
                // ese grupo podrá realizar todo en el componente. Si un grupo tiene añadido un componente con permisos extendidos, se tendrá que indicar si es
                // solo lectura, editar propios o editar todos
                if(this.componenteEditando.id){
                    if(!this.componentes.filter(componente => componente.id === this.componenteEditando.id)[0].permisoExtendido){
                        return this.permisos.filter(permiso => permiso.id === 3);
                    }
                    return this.permisos;
                }
            },
            errorComponente () {
                if (this.$v.componenteEditando.id.$dirty){
                    if (this.$v.componenteEditando.id.$invalid){
                        return 'Selecciona un componente';
                    }
                }
            },
            errorPermiso () {
                if (this.$v.componenteEditando.permisos.$dirty){
                    if (this.$v.componenteEditando.permisos.$invalid){
                        return 'Selecciona un permiso para el componente';
                    }
                }
            }
        }
    }
</script>